import React from 'react';
import { connect } from 'react-redux'
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import Switch from 'react-bootstrap-switch';

import Storage from '../../utils/Storage';
import { Drawer } from '@material-ui/core';

var Settings = createReactClass({

    propTypes: {
        onChange: pt.func.isRequired,
        onClose: pt.func.isRequired,
        active: pt.bool,
        getOnlyPrivate: pt.bool.isRequired,
        liveOnly: pt.bool.isRequired,
        resultMax: pt.any.isRequired,
        viewType: pt.shape({
            key: pt.string.isRequired,
            label: pt.string.isRequired
        })
    },

    closeSettings: function (ev) {
        if (ev) ev.preventDefault();
        this.props.onClose();
    },

    updateResultMax: function (ev) {
        ev.preventDefault();
        const viewsResultMax = Storage.get('VIEW_RESULT_MAX') || {}
        Storage.set(`VIEW_RESULT_MAX`, {...viewsResultMax, [this.props.viewType.key]: ev.target.value})
        this.props.onChange({
            resultMax: ev.target.value
        });
    },

    updateLiveOnly: function (el, value) {
        this.props.onChange({
            liveOnly: value
        });
    },

    updatePrivateOnly: function (el, value) {
        this.props.onChange({
            getOnlyPrivate: value
        });
    },

    render: function () {

        return (
          <Drawer
            anchor='right'
            open={this.props.active}
            onClose={this.closeSettings}
          >
            <div id='event-listing-settings'>
              <ul>
                <li className='text-right'>
                  <a
                    href=''
                    onClick={this.closeSettings}
                    className='close-settings'
                  >
                    <i className='fa fa-times' />
                  </a>
                </li>

                <li>
                  <label>Per-page Event Count</label>
                  <select
                    className='form-control'
                    value={this.props.resultMax}
                    onChange={this.updateResultMax}
                  >
                    {this.renderResultMaxOptions()}
                  </select>
                </li>

                <li>
                  <label>Live Events Only</label>
                  <Switch
                    onChange={this.updateLiveOnly}
                    value={this.props.liveOnly}
                    animate={false}
                  />
                </li>

                <li>
                  <label>Private Events Only</label>
                  <Switch
                    onChange={this.updatePrivateOnly}
                    value={this.props.getOnlyPrivate}
                    animate={false}
                  />
                </li>
              </ul>
            </div>
          </Drawer>
        )
    },

    renderResultMaxOptions: function () {
        const pageCounts = [5, 10, 25, 50, 75, 100]
        return pageCounts.map(pageCount => (
            <option
                key={`page option ${pageCount}`}
                value={pageCount}
            >
                {pageCount}
            </option>
        ))
    }

});

const mapStateToProps = state => {
    const { liveOnly, resultMax, getOnlyPrivate } = state.events.filters
    const { viewType } = state.events
    return { liveOnly, resultMax, getOnlyPrivate, viewType }
}

export default connect(mapStateToProps)(Settings);
